import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon, ViewIcon } from 'assets/icons';
import { GuideService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  area_id: '',
  type_id: '',
  date: '',
};

class AdminGuides extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['Fecha', 'Tipo de derecho', 'Tipo de Guía', 'Contenido', 'Acciones'],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    areas: [],
    types: [],
    visible: false,
    item: null,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Guías y Tutoriales',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.loadGuides();
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await GuideService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.guides.rows,
      last_page: res.guides.count,
    });
  };

  loadGuides = async () => {
    const res: any = await GuideService.admin.getAreas({
      withoutLoading: true,
    });
    this.setState({
      areas: res.areas || [],
      types: res.types || [],
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  delete = (e: any, item: any) => {
    e.preventDefault();
    Globals.confirm('¿Desea eliminar la guía?', async () => {
      await GuideService.admin.delete({
        guide_id: item.id,
      });
      this.load(true);
    });
  };

  add = () => {
    this.setState({
      visible: true,
    });
  };

  render() {
    const { visible } = this.state;

    return (
      <div id='admin-guides'>
        <Modal
          className='modal-create-guide'
          visible={visible}
          title={`${this.state.item ? 'Editar' : 'Nueva'} guía/tutorial`}
          onClose={() => this.onClose()}
        >
          <ModalCreate
            types={this.state.types}
            areas={this.state.areas}
            item={this.state.item}
            onClose={() => this.onClose()}
          />
        </Modal>

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-3'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Tipo de Guía'
                  name='type_id'
                  onChange={(e: any) =>
                    this.change(
                      {
                        target: {
                          name: 'type_id',
                          value: e.target.value,
                        },
                      },
                      async () => {
                        if (Number(this.state.form.type_id) === Constants.GUIDE_TYPES.YOUTUBE) {
                          this.change({ target: { name: 'area_id', value: '' } }, () =>
                            this.load(true),
                          );
                          return;
                        }

                        this.load(true);
                      },
                    )
                  }
                  value={this.state.form.type_id}
                  options={this.state.types.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className='col-md-3'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Tipo de derecho'
                  name='area_id'
                  disabled={Number(this.state.form.type_id) === Constants.GUIDE_TYPES.YOUTUBE}
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.area_id}
                  options={this.state.areas.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className='col-md-3'>
                <DatePicker
                  label='Fecha'
                  placeholder='Fecha'
                  maxDate={moment().toDate()}
                  onChange={(text: string) => {
                    this.change(
                      {
                        target: {
                          value: text,
                          name: 'date',
                        },
                      },
                      () => this.load(true),
                    );
                  }}
                  value={this.state.form.date}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title='Guías y Tutoriales'
          data={this.state.data.length}
          header={this.state.header}
          rightAlign={[4]}
          titleRight={
            <>
              {checkPermission(Constants.MODULES.GUIDES, 'write') && (
                <div className='container-add-table' onClick={() => this.add()}>
                  <p>Nuevo</p>
                  <button className='btn add-btn-table'>
                    <img src={AddIcon} />
                  </button>
                </div>
              )}
            </>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{moment(i.created_at).format('DD/MM/YYYY')}</td>
                <td>{i.area?.name || '-'}</td>
                <td>{i.type?.name || '-'}</td>
                <td>{i.type_id === Constants.GUIDE_TYPES.YOUTUBE ? i.name || '-' : 'Archivo'}</td>
                <td className='text-right'>
                  {i.file != null && (
                    <Tooltip title='Ver'>
                      <a
                        className='link-icon'
                        target='_blank'
                        href={Constants.BASE_STORAGE + i.file}
                      >
                        <img src={ViewIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {i.type_id === Constants.GUIDE_TYPES.YOUTUBE && i.youtube_video_id != null && (
                    <Tooltip title='Ver video'>
                      <a
                        className='link-icon'
                        target='_blank'
                        href={`https://www.youtube.com/watch?v=${i.youtube_video_id}`}
                      >
                        <img src={ViewIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {checkPermission(Constants.MODULES.GUIDES, 'write') && (
                    <Tooltip title='Editar'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.edit(e, i)}>
                        <img src={EditIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {checkPermission(Constants.MODULES.GUIDES, 'delete') && (
                    <Tooltip title='Eliminar'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.delete(e, i)}>
                        <img src={TrashIcon} />
                      </a>
                    </Tooltip>
                  )}
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminGuides);
